import { TextInputField } from "@bps/fluent-ui";
import { FunctionComponent } from "react";

interface PremSettingValueFieldProps {
  index: number;
  hasWritePermissions: boolean;
}

export const PremSettingValueField: FunctionComponent<PremSettingValueFieldProps> = ({
  index,
  hasWritePermissions
}) => {
  const settingValueCol = `updateValues[${index}].settingValue`;

  return (
    <TextInputField name={settingValueCol} disabled={!hasWritePermissions} />
  );
};
